// extracted by mini-css-extract-plugin
export default {"standardFilterList":"StandardFilterList_standardFilterList__HqjfH"};